<template>
  <div class="box">
    <div id="app-home">
      <div class="tree">
        <div class="treeList">
          <el-tree
            :data="treeList"
            :show-checkbox="true"
            node-key="username"
            :props="defaultProps"
            :filter-node-method="filterNode"
            ref="tree"
            @check="checkTree"
            :default-expanded-keys="nodeList"
          >
            <div class="custom-tree-node" slot-scope="{ data }">
              <div>
                <img v-if="data.child && data.child.length > 0" src="@/assets/depament1.svg" alt="" />
                <span>
                  <template v-if="data.type === 'user'">
                    {{data.nickname}}
                  </template>
                  <template v-else>
                    {{data.departmentName}}
                  </template>
                </span>
              </div>
              <span v-if="data.child && data.child.length > 0">
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
          </el-tree>
        </div>
      </div>
      <div class="submit">
        <el-button class="button" @click="query">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
// import moment from "moment";
export default {
  name: "home",
  data() {
    return {
      treeList: [],
      defaultProps: {
        children: "child",
        // label: "departmentName",
      },
      list: {},
      nodeList: [],
      nickname: '',
      usernames: '',
    };
  },
  created() {},
  mounted() {
    this.getList();
    this.init()
  },
  methods: {
    // 获取部门树
    init() {
      let usernames = this.$route.query.usernames && this.$route.query.usernames.split(',');
      if (usernames) {
        this.nodeList.push(...usernames);
        this.$refs.tree.setCheckedKeys(this.nodeList, true);
      }
      if (sessionStorage.getItem("changeInfoDepament")) {
        this.list = JSON.parse(sessionStorage.getItem("changeInfoDepament"))
      }
    },
    // 获取部门树数据
    getList() {
      api.directory().then((data) => {
        this.treeList = data.data;
      });
    },
    // 处理树节点选中事件
    checkTree(data) {
      this.list = data
      
      // if (data.child) {
      //   this.$refs.tree.setCurrentKey(data.id);
      //   this.$refs.tree.setCheckedKeys([data.id]);
      // }

      const nodes = this.$refs.tree.getCheckedNodes(true);
      
      // 处理推送对象用户名集合
      this.nickname = nodes.map(item => {
        let nickname = ''
        if (item.nickname) {
          nickname += item.nickname
        }
        return nickname
      })
      this.usernames = nodes.map(item => {
        let username = ''
        if (item.username) {
          username += item.username
        }
        return username
      })
    },
    // 过滤树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },
    // 确认选择部门
    query() {
      sessionStorage.setItem("changeInfoDepament", JSON.stringify(this.list));
      this.nickname && sessionStorage.setItem("nickname", this.nickname.join());
      this.usernames && sessionStorage.setItem("usernames", this.usernames.join());
      this.$router.back()
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
  }
}
.box {
  width: 100%;
  display: flex;
  justify-content: center;
}
#app-home {
  font-size: 16px * $zoom;
  position: relative;
  background: rgba(247, 249, 250, 1);
  min-height: 100vh;
  //   padding: 20px;
}
.tree {
  background: #ffffff;
  height: 1100px;
  .input {
    margin: 20px 0;
    ::v-deep .el-input__inner {
      width: 90%;
      height: 70px;
      margin-left: 5%;
      padding-left: 70px;
      background: rgba(235, 237, 242, 1);
      border: none;
    }
    ::v-deep .el-input__icon {
      margin-left: 40px;
      font-size: 34px;
      margin-top: 3px;
    }
  }
  .treeList {
    height: 940px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  ::v-deep .el-checkbox {
    padding-left: 20px;
    .el-checkbox__inner {
      width: 36px;
      height: 36px;
      &::before {
        top: 15px;
      }
      &::after {
        top: 3px;
        left: 11px;
        height: 20px;
        width: 10px;
      }
    }
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    display: none;
  }
  ::v-deep .el-tree-node__content {
    display: flex;
    height: 100px !important;
    padding: 0 20px;
    border-bottom: 1px solid #f6f6f6;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    div {
      margin-left: 15px;
      display: flex;
      align-items: center;
      span {
        font-size: 32px;
        margin-left: 20px;
      }
    }
  }
  .el-icon-arrow-right {
    font-size: 32px;
    color: #ccc;
  }
}
.submit {
  position: absolute;
  bottom: 100px;
  width: 80%;

  .button {
    width: 100%;
    background: rgba(78, 162, 124, 1);
    color: #fff;
    height: 80px;
    font-size: 30px;
    padding-top: 15px;
    border-radius: 20px;
    margin-left: 12.5%;
  }
}
</style>
